var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feather-icon / info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 8.50002C0.666748 4.44993 3.94999 1.16669 8.00008 1.16669C12.0502 1.16669 15.3334 4.44993 15.3334 8.50002C15.3334 12.5501 12.0502 15.8334 8.00008 15.8334C3.94999 15.8334 0.666748 12.5501 0.666748 8.50002ZM8.00008 2.50002C4.68637 2.50002 2.00008 5.18631 2.00008 8.50002C2.00008 11.8137 4.68637 14.5 8.00008 14.5C11.3138 14.5 14.0001 11.8137 14.0001 8.50002C14.0001 5.18631 11.3138 2.50002 8.00008 2.50002Z",
    fill: "#64687D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 7.83331C8.36811 7.83331 8.66659 8.13179 8.66659 8.49998V11.1666C8.66659 11.5348 8.36811 11.8333 7.99992 11.8333C7.63173 11.8333 7.33325 11.5348 7.33325 11.1666V8.49998C7.33325 8.13179 7.63173 7.83331 7.99992 7.83331Z",
    fill: "#64687D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 7.99992,
    cy: 5.83335,
    r: 0.666667,
    fill: "#64687D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.5693a1975139d68e5f0006441a9cc9e8.svg";
export { ForwardRef as ReactComponent };